import { h, Component, Fragment } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { toJS } from 'mobx';
import linkstate from 'linkstate';
import { route } from 'preact-router';
import { Text, Localizer, withText } from 'preact-i18n';
import md5 from 'crypto-js/md5';

@observer
class DecimalInput extends Component {
    state = {
        inputValue: this.props.value || '',
        parsedNumber: null
    };

    handleNumericInput = (event) => {
        const { onChange = () => {} } = this.props;
        let inputValue = event.target.value;

        // Replace all commas with dots
        inputValue = inputValue.replace(/,/g, '.');

        // Remove invalid characters (allow numbers, dots, and optional minus)
        let sanitizedValue = inputValue.replace(/[^0-9.-]/g, '');

        // Handle multiple dots
        const parts = sanitizedValue.split('.');
        if (parts.length > 2) {
            sanitizedValue = parts[0] + '.' + parts.slice(1).join('');
        }

        // Handle minus sign
        if (sanitizedValue.startsWith('-')) {
            sanitizedValue = '-' + sanitizedValue.replace(/-/g, '');
        } else {
            sanitizedValue = sanitizedValue.replace(/-/g, '');
        }

        // Hand the sanitised value of THIS keystroke to the consumer before calling onChange.
        // Input.onInput reads `dataset.parsedvalue || value`; the rendered data-parsedvalue is
        // still the previous keystroke's number, and the raw value may carry a Norwegian comma
        // ("245,6") that Number() turns into NaN downstream (T-01851).
        event.target.dataset.parsedvalue = sanitizedValue;
        // Call onChange while event.target.value is still the original value
        onChange(event);

        // Then update internal state
        this.setState({ inputValue: sanitizedValue }, () => {
            const parsedNumber = parseFloat(sanitizedValue);
            if (!isNaN(parsedNumber)) {
                this.setState({ parsedNumber });
            } else {
                this.setState({ parsedNumber: null });
            }
        });
    }

    handleFocus = (event) => {
        const { onFocus = () => {} } = this.props;
        // Select the input value on focus
        event.target.select();
        onFocus(event);
    }

    componentDidMount() {
        const { value } = this.props;
        if (value) {
            this.setState({ inputValue: value });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== this.state.inputValue) {
            this.setState({ inputValue: this.props.value || '' });
        }
    }

    render() {
        const { inputValue, parsedNumber } = this.state;
        const {
            className = '',
            style = '',
            object = {},
            field,
            type,
            elementtype,
            extraDataset = {},
            placeholder,
            onBlur = () => {},
        } = this.props;
        return (
            <>
                {/* <div>Parsed Number: {parsedNumber}</div> */}
                <input
                    class={className}
                    style={style}
                    onFocus={this.handleFocus}
                    onBlur={onBlur}
                    name={field}
                    type='text'
                    pattern='^[0-9.,\-]*$'
                    inputmode='decimal'
                    onInput={this.handleNumericInput}
                    value={inputValue}
                    data-parsedvalue={parsedNumber}
                    data-id={object.id}
                    data-md5={object.md5 || md5(JSON.stringify(toJS(object))).toString()}
                    data-field={field}
                    data-datatype={type}
                    data-elementtype={elementtype}
                    {...extraDataset}
                    placeholder={placeholder}
                />
            </>
        );
    }
}

export default DecimalInput;
